import { render, staticRenderFns } from "./Slider-Module.vue?vue&type=template&id=ddc1da1e&"
import script from "./Slider-Module.vue?vue&type=script&lang=js&"
export * from "./Slider-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports